import Vue from "vue";
import Router from "vue-router";

import AppHeader from "./cuerpo/Header";
import AppFooter from "./cuerpo/Footer";

import Index from "./vistas/Home";
import paso1 from "./vistas/paso-1";
import paso2 from "./vistas/paso-2";
import paso3 from "./vistas/paso-3";

import AppServicio from "./vistas/app";

Vue.use(Router);

const router = new Router({
    linkExactActiveClass: "active",
    mode:   "history" ,
    routes: [
        {
            path: "/",
            components: {
                header: AppHeader,
                default: Index,
                footer: AppFooter
            },
            name: "Home",
        },
        {
            path: "/paso-1",
            name: "p1",
            components: {
                header: AppHeader,
                default: paso1,
                footer: AppFooter
            }
        },
        {
            path: "/paso-2",
            name: "p2",
            components: {
                header: AppHeader,
                default: paso2,
                footer: AppFooter
            }
        },
        {
            path: "/paso-3",
            name: "p3",
            components: {
                header: AppHeader,
                default: paso3,
                footer: AppFooter
            }
        },
        {
            path: "/app/:agencia?/:orden?",
            name: "app",
            components: {
                header: AppHeader,
                default: AppServicio,
                footer: AppFooter
            }
        },
        {
            path:"*",
            name:"404",
            redirect: { name: 'Home' }
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            if(Object.keys(to.query).length===0)
                return { x: 0, y: 0 };
        }
    }
});
const DEFAULT_TITLE = document.title=process.env.VUE_APP_TITLE || "Colisiones Web";
router.afterEach((to) => {
    document.title = to.meta.title || DEFAULT_TITLE;
});
export default router;
